import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from '@tanstack/react-query';
import { PackageCheck } from 'lucide-react';
import { DataTable, EmptyState, PageHeader } from '@/components/ui';
import { api } from '@/lib/api';
export function ReorderPage() {
    const suggestions = useQuery({
        queryKey: ['reorder-suggestions'],
        queryFn: async () => (await api.get('/inventory/reorder-suggestions/')).data,
    });
    return (_jsxs("div", { className: "space-y-6", children: [_jsx(PageHeader, { title: "Reorder suggestions", description: "Products at or below their reorder point. Lead-time aware quantities suggested." }), _jsx(DataTable, { rows: suggestions.data, loading: suggestions.isLoading, rowKey: (r) => r.product_id, empty: _jsx(EmptyState, { icon: _jsx(PackageCheck, { className: "h-6 w-6" }), title: "All stock levels are healthy", description: "Nothing has dipped below its reorder point." }), columns: [
                    { key: 'sku', header: 'SKU', render: (r) => _jsx("code", { className: "font-mono text-xs", children: r.sku }) },
                    { key: 'name', header: 'Product', render: (r) => _jsx("span", { className: "font-medium", children: r.name }) },
                    {
                        key: 'on_hand', header: 'On hand', align: 'right',
                        render: (r) => (_jsx("span", { className: "font-mono font-semibold text-amber-600", children: Number(r.on_hand).toLocaleString() })),
                    },
                    {
                        key: 'pt', header: 'Reorder pt', align: 'right',
                        render: (r) => _jsx("span", { className: "font-mono", children: r.reorder_point }),
                    },
                    {
                        key: 'safety', header: 'Safety', align: 'right',
                        render: (r) => _jsx("span", { className: "font-mono", children: r.safety_stock }),
                    },
                    {
                        key: 'qty', header: 'Suggested qty', align: 'right',
                        render: (r) => _jsx("span", { className: "font-mono font-semibold", children: r.reorder_quantity }),
                    },
                    {
                        key: 'lt', header: 'Lead', align: 'right',
                        render: (r) => _jsxs("span", { className: "text-muted-foreground", children: [r.lead_time_days, "d"] }),
                    },
                ] })] }));
}
